<template>
  <div class="control-section e-tab-section">
    <div class="content-wrapper">
      <div class="e-sample-resize-container" id="dialog_target">
        <div id='weighta' >
          <CCard>
            <CCardBody>
              <CRow>
                <CCol sm="4" lg="4">
                  <div class="content-wrapper">
                    <div id="app">
                      <ejs-tooltip  target=".e-rowcell" >
                        <ejs-grid ref='refFormula' locale='zh-TW' :dataSource='formulaDatas' height='582' :allowExcelExport='true'
                           :allowPaging='false' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :rowDataBound="onRowDataBound"
                           :toolbar='formulaToolbar' :queryCellInfo='onQueryCellInfo' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                           :toolbarClick="formulaToolbarClick" :recordDoubleClick="formulaDoubleClick" :editSettings='editSettings' :rowSelected="formulaRowSelected">
                          <e-columns>
                            <e-column field='formula_id' headerText='配方編號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                            <e-column field='formula_name' headerText='配方名稱' width='180'></e-column>
                            <e-column field='adjust_temp' headerText='調理溫度'  textAlign="Right" width='180'></e-column>
                            <e-column field='adjust_brix' headerText='調理糖度'  textAlign="Right" width='180'></e-column>
                          </e-columns>
                        </ejs-grid>
                      </ejs-tooltip>
                    </div>
                  </div>
                </CCol>               
                <CCol sm="8" lg="8">
                  <div style="padding-bottom:10px;">
                    <ejs-radiobutton label="投料順序" name="sort" value="put" :checked="true" :change="radiobuttonChange"></ejs-radiobutton>&nbsp; &nbsp;
                    <ejs-radiobutton label="成品編號" name="sort" value="package" :change="radiobuttonChange"></ejs-radiobutton>
                  </div>
                  <div id="app">
                    <div v-if="isproduct">
                      <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                        <ejs-grid ref='refPutMaterials' locale='zh-TW' :dataSource='putMaterialsData' height='550' :allowExcelExport='true' :rowDataBound="onRowDataBound"
                          :allowPaging='false' :allowSorting='false' :allowFiltering='false' :allowReordering='true' :allowRowDragAndDrop="true"
                          :toolbar='putMaterialsToolbar' :queryCellInfo='onQueryCellInfo' :pageSettings='pageSettings' :filterSettings='filterSettings' :editSettings='editSettings' :rowDrop='onRowDrop'
                          :selectionSettings='selectionSettings' :recordDoubleClick="putMaterialsDoubleClick" :toolbarClick="putMaterialsToolbarClick" :rowSelected="putMaterialsRowSelected">                          
                          <e-columns>                         
                            <e-column field='pot_name' headerText='流程' :template='potTemplate' aria-required="true" width='120'></e-column>                   
                            <e-column field='sort' headerText='順序' width='70' ></e-column>   
                            <e-column field='monitor_name' headerText='說明' width='500' textAlign='Left' ></e-column>    
                          </e-columns>
                        </ejs-grid>
                      </ejs-tooltip>
                    </div>
                    <div v-if="!isproduct">
                      <CRow>
                        <CCol sm="12" lg="12">
                          <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refProduct' locale='zh-TW' :dataSource='productDatas' height='200' :allowExcelExport='true'
                              :allowPaging='false' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                              :toolbar='productToolbar' :pageSettings='pageSettings' :filterSettings='filterSettings'
                              :selectionSettings='selectionSettings' :queryCellInfo='onQueryCellInfo' :toolbarClick="ProductToolbarClick"
                              :editSettings='editSettings' :recordDoubleClick="productDoubleClick" :rowSelected="productRowSelected">
                              <e-columns>
                                <e-column field='product_id' headerText='成品編號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                <e-column field='product_name' headerText='成品名稱' width='240'></e-column>
                                <e-column field='product_classification_id' headerText='成品分類代碼' width='180'></e-column>
                                <e-column field='product_classification_name' headerText='成品分類名稱' width='180'></e-column>
                                <e-column field='product_classification_big_id' headerText='成品大類代碼' width='180'></e-column>
                                <e-column field='product_classification_big_name' headerText='成品大類名稱' width='180'></e-column>
                                <e-column field='is_stop' headerText='停用否' width='180'></e-column>
                                <e-column field='stop_date' headerText='停用日期' width='180'></e-column>
                                <e-column field='format' headerText='規格' width='140' textAlign='Right'></e-column>
                                <e-column field='safety_stock' headerText='安全庫存' width='140' textAlign='Right'></e-column>
                                <e-column field='stock_in_date' headerText='最近入庫日期' width='140' textAlign='Left'></e-column>
                                <e-column field='stock_out_date' headerText='最近出庫日期' width='140' textAlign='Left'></e-column>
                                <e-column field='stock' headerText='主要庫別' width='140' textAlign="Right"></e-column>
                                <e-column field='barcode' headerText='條碼' width='140' textAlign='Left'></e-column>
                                <e-column field='max_stock' headerText='最高存量' width='140' textAlign='Right'></e-column>
                                <e-column field='total_stock' headerText='總庫存' width='140' textAlign='Right'></e-column>
                                <e-column field='package_convert_modulus' headerText='包裝轉換係數' width='200' textAlign='Right'></e-column>
                                <e-column field='litron_convert_modulus' headerText='公升轉換係數' width='200' textAlign='Right'></e-column>
                                <e-column field='capacity' headerText='容量' width='140' textAlign='Right'></e-column>
                                <e-column field='b_weight' headerText='充填重量(下限)' width='180' textAlign='Right'></e-column>
                                <e-column field='e_weight' headerText='充填重量(上限)' width='180' textAlign='Right'></e-column>
                                <e-column field='b2_weight' headerText='檢重機重量/箱(下限)' width='200' textAlign='Right'></e-column>
                                <e-column field='e2_weight' headerText='檢重機重量/箱(上限)' width='200' textAlign='Right'></e-column>
                              </e-columns>
                            </ejs-grid>
                          </ejs-tooltip>
                        </CCol>
                        <CCol sm="12" lg="12" style="padding-top: 15px;">
                          <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refFormula' locale='zh-TW' :dataSource='materialDatas' height='200' :allowExcelExport='true'
                              :allowPaging='true' :allowSorting='true' :queryCellInfo='onQueryCellInfo' :allowFiltering='true' :allowReordering='true'
                              :toolbar='materialToolbar' :toolbarClick="materialToolbarbarClick" :pageSettings='pageSettings' :filterSettings='filterSettings'
                              :selectionSettings='selectionSettings' >
                              <e-columns>
                                <e-column field='material_id' headerText='子階品號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                <e-column field='material_name' headerText='子階品名' width='180' ></e-column>
                                <e-column field='process' headerText='加工別' width='120' textAlign='Left' ></e-column>
                                <e-column field='use' headerText='單位用量' width='120' textAlign='Right'></e-column>
                                <e-column field='use_unit' headerText='單位' width='120' textAlign='Right'></e-column>
                                <e-column field='convert_modulus' headerText='換算分母' width='120' textAlign='Right' ></e-column>
                              </e-columns>
                            </ejs-grid>
                          </ejs-tooltip>
                        </CCol>
                      </CRow>                     
                    </div>
                  </div>                 
                </CCol>

                <ejs-dialog ref="FormulaDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_formula_isAdd ? "新增配方" : "修改配方"' :buttons='e_formula_buttons' width='400px'>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="alert alert-primary" role="alert">
                        建立配方表，可在生產排程中建立配方資料，有設定調理溫度及糖度超過時將會警告。
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <span class="about-title-verify">配方編號</span>
                      <ejs-textbox floatLabelType="Always" v-model="e_formula_id" :enabled="e_formula_isAdd" aria-required="true"></ejs-textbox>
                    </div>    
                    <div class="form-group col-md-6">
                      <span class="about-title-verify">配方名稱</span>
                      <ejs-textbox floatLabelType="Always" v-model="e_formula_name" ></ejs-textbox>
                    </div>   
                    <div class="form-group col-md-6">
                      <span class="about-title" >調理溫度</span>                      
                      <ejs-numerictextbox format="###.## ˚C"  :step="0.1" :min="0" v-model="e_adjust_temp"></ejs-numerictextbox>   
                    </div>    
                    <div class="form-group col-md-6">
                      <span class="about-title" >調理糖度</span>                      
                      <ejs-numerictextbox format="###.## Brix"  :step="0.1" :min="0" v-model="e_adjust_brix"></ejs-numerictextbox>   
                    </div>                                 
                  </div>                  
                </ejs-dialog>
              
                <ejs-dialog ref="ProductLinkDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true'  :visible='false' :header='"配方與成品連結"' :buttons='e_product_link_buttons' width='900px'>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="alert alert-primary" role="alert">
                        配方資料建立後，成品資料由名鑰MIS整合，MIS建立完成後再未建立項目即有項目產生，再搭配配方資料進行整合；子階編號可在MIS中BOM表管理進行設定。
                      </div>
                    </div>
                    <div class="form-group col-md-12">
                      <div class="control-section">
                        <div class="dual-list-wrapper">
                            <div class="dual-list-groupa">                          
                                <h6>已建立</h6> 
                                <ejs-listbox id="lis_product_bind" ref="lis_product_bind" :dataSource="productBindDatas" :fields="fields" :noRecordsTemplate='nTemplate' height="330px" scope="#connected-listbox" :toolbarSettings="toolbarSettings"></ejs-listbox>
                            </div>
                            <div class="dual-list-groupb">
                                <h6>未建立</h6>
                                <ejs-listbox cssClass="my-listbox-style" id="connected-listbox" :dataSource="productNoneBindDatas" :noRecordsTemplate='nTemplate' height="330px" :fields="fields"></ejs-listbox>
                            </div>
                        </div>                           
                      </div>
                    </div>
                  </div>
                </ejs-dialog>     

                <ejs-dialog ref="ProductDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true'  :visible='false' :header='"成品物料修正"' :buttons='e_product_buttons'   width='400px'>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="alert alert-primary" role="alert">
                        如成品設定包裝重量，可在檢重機上進行檢測；公升轉換係數為該成品一個項目可煮多少公升(L)
                      </div>
                    </div>  
                    <div class="form-group col-md-6">
                      <span class="about-title-verify">成品編號</span>
                      <ejs-textbox id="ProductNo"  floatLabelType="Always" :enabled="false" v-model="e_product_id" ></ejs-textbox>
                    </div>    
                    <div class="form-group col-md-6">
                      <span class="about-title-verify">成品品名</span>
                      <ejs-textbox id="ProductName" floatLabelType="Always" :enabled="false" v-model="e_product_name" ></ejs-textbox>
                    </div>    
                    <div class="form-group col-md-6">
                      <span class="about-title">充填重量(下限)</span>                      
                      <ejs-numerictextbox id="numeric" format="###.## g"  :step="0.1" :min="0" v-model="e_product_b_weight"></ejs-numerictextbox>   
                    </div>    
                     <div class="form-group col-md-6">
                      <span class="about-title">充填重量(上限)</span>                      
                      <ejs-numerictextbox id="numeric" format="###.## g"  :step="0.1" :min="0" v-model="e_product_e_weight"></ejs-numerictextbox>   
                    </div>  
                      <div class="form-group col-md-6">
                      <span class="about-title">檢重機重量/箱(下限)</span>                      
                      <ejs-numerictextbox id="numeric" format="###.## g"  :step="0.1" :min="0" v-model="e_box_b_weight"></ejs-numerictextbox>   
                    </div>    
                     <div class="form-group col-md-6">
                      <span class="about-title">檢重機重量/箱(上限)</span>                      
                      <ejs-numerictextbox id="numeric" format="###.## g"  :step="0.1" :min="0" v-model="e_box_e_weight"></ejs-numerictextbox>   
                    </div>   
                      <div class="form-group col-md-6">
                      <span class="about-title">容量</span>                      
                      <ejs-numerictextbox id="numeric" format="##### mL"  :step="1" :min="0" v-model="e_product_capacity"></ejs-numerictextbox>   
                    </div>       
                    <div class="form-group col-md-6">
                      <span class="about-title">公升轉換係數</span>                      
                      <ejs-numerictextbox id="numeric" format="###.## L"  :step="0.1" :min="0" v-model="e_product_litron"></ejs-numerictextbox>   
                    </div>                                        
                  </div>                
                </ejs-dialog>
                
                <ejs-dialog ref="putMaterialsDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true'  :visible='false' :header='e_put_materials_isAdd ? "新增投料步驟" : "修改投料步驟"' :buttons='e_put_matera_buttons' width='700px'>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="alert alert-primary" role="alert">
                        投料步驟可在工作站的工作進度，數值均採用1500L計算，系統將自動換算。品質檢驗部分如有不檢驗的狀態,低標及高標輸入0。
                      </div>
                    </div>
                    <div class="form-group col-md-4">                   
                      <span class="about-title-verify">工作站</span>
                      <ejs-dropdownlist :dataSource='potData' allowObjectBinding='true' v-model="e_put_materials_pot" :fields='dropDownFields' @change="workOnchange"></ejs-dropdownlist>
                    </div>                      
                    <div class="form-group col-md-4">                  
                       <!--<div v-if="e_put_materials_pot == 1">
                        <span class="about-title-verify">剪切機</span><br/> 
                         <div style="padding-top: 10px;"> 否 &nbsp; <ejs-switch id="unchecked" :checked="e_put_materials_cutting" @change="cuttingOnchange"></ejs-switch> &nbsp; 是 </div>
                      </div>-->    
                    </div>   
                    <div class="form-group col-md-4">                  
                      
                    </div>    
                    <div class="form-group col-md-12">
                      <span class="about-title-verify">監測及輸入項目</span>
                      <div class="vertical-stack" style="padding-left: 20px; padding-top: 20px;">
                        <div class="form-row">
                        <div v-if="e_put_materials_pot == 1 || e_put_materials_pot == 2 || e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="僅說明" name="monitor" value="none" :checked="e_put_materials_type == -1" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 1 || e_put_materials_pot == 2 || e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="一般投料" name="monitor" value="put" :checked="e_put_materials_type == 0" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot != 1 && e_put_materials_pot != 2" class="form-group col-md-3"><ejs-radiobutton label="品質管理" name="monitor" value="qc" :checked="e_put_materials_type == 1" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="濾袋壓力" name="monitor" value="pressure" :checked="e_put_materials_type == 2" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="參考液位值" name="monitor" value="level" :checked="e_put_materials_type == 3" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 1 || e_put_materials_pot == 2 || e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="其他輸入" name="monitor" value="input" :checked="e_put_materials_type == 10" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 1 || e_put_materials_pot == 2 || e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="其他選項" name="monitor" value="select" :checked="e_put_materials_type == 11" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="液位值計算" name="monitor" value="level_calculate" :checked="e_put_materials_type == 20" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="循環加熱殺菌完畢" name="monitor" value="cycle" :checked="e_put_materials_type == 21" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                        <div v-if="e_put_materials_pot == 3" class="form-group col-md-3"><ejs-radiobutton label="補料" name="monitor" value="material" :checked="e_put_materials_type == 22" :change="radiobuttonMonitorChange"></ejs-radiobutton></div>
                      </div>
                      </div>                      
                    </div>  
                    <div class="form-group col-md-12">             

                      <div v-show="e_put_materials_type == 0" class="form-row"> <!--投料-->
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">投料內容</span>
                          <ejs-dropdownlist :dataSource='materialsListData' allowObjectBinding='true' :allowFiltering='true' v-model="e_put_materials_id" :fields='dropDownFields'  ></ejs-dropdownlist>                  
                        </div>   
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">投料量</span>     
                          <ejs-numerictextbox format="#####.#####" :showSpinButton='false' :step="0" v-model="e_put_materials_percentage"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">單位</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_unit" ></ejs-textbox>     
                        </div> 
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">按鈕說明</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_button_text" ></ejs-textbox> 
                           <span style="text-align: right; color: blue;"> 如需要輸入相關參數時,可輸入各項參數 </span>  
                        </div>   
                      </div>  
                    
                      <div v-show="e_put_materials_type == 1 && (e_put_materials_pot == 1 || e_put_materials_pot == 2)" class="form-row"> <!--QC-->
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">溫度(低)</span>    
                          <ejs-numerictextbox format="#####.#˚C" :step="1" v-model="e_put_materials_temp_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">溫度(高)</span>  
                          <ejs-numerictextbox  format="#####.#˚C" :step="1" v-model="e_put_materials_temp_high"></ejs-numerictextbox>         
                        </div>                     
                      </div>

                      <div v-show="e_put_materials_type == 1 && e_put_materials_pot == 3" class="form-row"> <!--QC-->
                        <div class="form-group col-md-3" v-show="false">              
                          <span class="about-title-verify">溫度(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#˚C" :step="1" v-model="e_put_materials_temp_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3" v-show="false">              
                          <span class="about-title-verify">溫度(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#˚C" :step="1" v-model="e_put_materials_temp_high"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">糖度(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#°Bx" :step="1" v-model="e_put_materials_brix_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">糖度(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#°Bx" :step="1" v-model="e_put_materials_brix_high"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">酸度(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.##％" :step="1" v-model="e_put_materials_ph_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">酸度(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.##％" :step="1" v-model="e_put_materials_ph_high"></ejs-numerictextbox>         
                        </div>  
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">鹽度(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.##％" :step="1" v-model="e_put_materials_salinity_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">鹽度(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.##％" :step="1" v-model="e_put_materials_salinity_high"></ejs-numerictextbox>         
                        </div>  

                      </div>
                       <div v-show="e_put_materials_type == 1 && e_put_materials_pot == 4" class="form-row"> <!--QC-->
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">溫度(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#˚C" :step="1" v-model="e_put_materials_temp_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">溫度(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#˚C" :step="1" v-model="e_put_materials_temp_high"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">糖度(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#°Bx" :step="1" v-model="e_put_materials_brix_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">糖度(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#°Bx" :step="1" v-model="e_put_materials_brix_high"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">比重</span>       
                          <ejs-numerictextbox id="numeric" format="#####.##" :step="1" v-model="e_put_materials_proportion"></ejs-numerictextbox>         
                        </div> 
                      </div>
                      <div v-show="e_put_materials_type == 2 && e_put_materials_pot == 3" class="form-row"> 
                        <div class="form-group col-md-4"> 
                          <span class="about-title-verify">按鈕說明</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_button_text" ></ejs-textbox>    
                        </div>  
                        <div class="form-group col-md-4">              
                          <span class="about-title-verify">濾袋壓力(低)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#kg/cm²" :step="1" v-model="e_put_materials_pressure_low"></ejs-numerictextbox>         
                        </div> 
                        <div class="form-group col-md-4">              
                          <span class="about-title-verify">濾袋壓力(高)</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#kg/cm²" :step="1" v-model="e_put_materials_pressure_high"></ejs-numerictextbox>         
                        </div>   
                      </div>
                      <div v-show="e_put_materials_type == 3 && e_put_materials_pot == 3" class="form-row"> 
                        <div class="form-group col-md-3">              
                          <span class="about-title-verify">參考液位值</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#L" :step="1" v-model="e_put_materials_refer_value"></ejs-numerictextbox>         
                        </div>
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">按鈕說明</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_button_text" ></ejs-textbox>    
                        </div>  
                      </div>

                      <div v-show="e_put_materials_type == 10" class="form-row"> 
                        <div class="form-group col-md-3">              
                          <span class="about-title">預設值</span>       
                          <ejs-numerictextbox id="numeric" format="#####.#" :step="1" v-model="e_put_materials_initial_value"></ejs-numerictextbox>         
                        </div>
                        <div class="form-group col-md-3">              
                          <span class="about-title">單位</span>       
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_unit" ></ejs-textbox>             
                        </div>
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">按鈕說明</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_button_text" ></ejs-textbox>    
                        </div>  
                      </div>

                      <div v-show="e_put_materials_type == 11" class="form-row"> 
                        <div class="form-group col-md-3">              
                          <span class="about-title">預設選項</span>       
                              <ejs-dropdownlist :dataSource='yesNoData' allowObjectBinding='true' v-model="e_put_materials_initial_value" :fields='dropDownFields'></ejs-dropdownlist>  
                        </div>           
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">按鈕說明</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_button_text" ></ejs-textbox>    
                        </div>             
                      </div>           
                      
                      <div v-show="e_put_materials_type == 20" class="form-row"> 
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">按鈕說明</span>
                          <ejs-textbox floatLabelType="Always" :enabled="true" v-model="e_put_materials_button_text" ></ejs-textbox>    
                        </div>  
                      </div>
                      <div v-show="e_put_materials_type != -1" class="form-row"> 
                        <div class="form-group col-md-12">
                          <span class="about-title-verify">說明</span>
                          <ejs-textbox  floatLabelType="Always" :showClearButton="true" v-model="e_put_materials_action" ></ejs-textbox>
                        </div>      
                      </div>    
                       <div v-show="e_put_materials_type == -1" class="form-row"> 
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">說明</span>
                          <ejs-textbox :multiline="true"  v-model="e_put_materials_action" ></ejs-textbox >
                        </div>  
                        <div class="form-group col-md-6">
                          <span class="about-title-verify">敘述</span>
                          <ejs-textbox :multiline="true"  v-model="e_put_materials_description" ></ejs-textbox >
                        </div>      
                      </div>       
                     </div>                        
                  </div>                  
                </ejs-dialog>
              </CRow>
              <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
            </CCardBody>
          </CCard>
        </div>  
      </div>
    </div>
  </div>
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script>

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { L10n, enableRipple } from '@syncfusion/ej2-base';
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { ToastComponent, } from "@syncfusion/ej2-vue-notifications";
import { ListBoxComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { TextBoxPlugin, NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import { GridComponent, ColumnDirective, ColumnsDirective,  Selection, RowDD} from '@syncfusion/ej2-vue-grids';
import zhtwLocalization  from '../language/language.json';

L10n.load(zhtwLocalization);


enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(TextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(TooltipPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;

var norecordVue = Vue.component( "noRecordsTemplate", {
  template: '<div class= "e-list-nrt"><span>查無資料</span></div>',
    data() {
        return {
          data: {}
        };
    }
});

export default {
  name: 'GetMaterials',
  components: {
    'ejs-toast': ToastComponent,
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-listbox': ListBoxComponent

  },
  data: function () {
    return {
   
      // 共用
      limit : localStorage.getItem('production'), 
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      filterSettings: { type: 'CheckBox' },
      dropDownFields: { text: 'text', value: 'value' },
      fields: { text: 'name'},
      selectionSettings: { persistSelection: false },
      pageSettings: { pageSizes: [15, 30, 50, 100], pageCount: 4 },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      isproduct : true,
      toolbarSettings: { items: ['moveUp', 'moveDown', 'moveTo', 'moveFrom', 'moveAllTo', 'moveAllFrom'] },
      nTemplate: function() {
          return {
              template: norecordVue
          };
      },

      // 配方
      formulaDatas: null, formulaToolbar: null,
      e_formula_isAdd: null, e_formula_selectRow: null,  e_formula_selectData: null, e_formula_id: null, e_formula_name: null, e_adjust_temp: null, e_adjust_brix: null, e_formula_status: null,
      e_formula_buttons: [
        {click: this.editFormulaOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],

      // 產品
      productDatas: null, productToolbar:null,
      productNoneBindDatas: null,
      productBindDatas: null,
      e_product_isAdd: null, e_product_name: null, e_product_id: null, e_product_selectRow: null,  e_product_selectData: null, e_product_status: null, 
      e_product_b_weight: null, e_product_e_weight: null, e_box_b_weight: null,e_box_e_weight: null,
      e_product_litron: null, e_product_capacity: null,
      e_product_buttons: [
        {click: this.editProductOkClick, buttonModel: { content: '確認', isPrimary: true || this.limit.indexOf('22') < 0 } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],
      e_product_link_buttons: [
        {click: this.editProductLinkOkClick, buttonModel: { content: '確認', isPrimary: true || this.limit.indexOf('22') < 0 } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消'}}
      ],

      // 用料
      materialDatas: null,
      materialToolbar: [
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' },
        'Search'],

      // 投料   
      yesNoData: [ 
        { text: '是', value: 1 },
        { text: '否', value: 0 },
      ], 
      materialsListData: null, 
      putMaterialsData: null, potData: null, materialListData: null, e_put_materials_status: null, putMaterialsToolbar: null,      
      e_put_materials_isAdd: null, 
      e_put_materials_sort_id: null,    // ID
      e_put_materials_pot: 1,           // 桶次
      e_put_materials_cutting: false,   // 裁切機
      e_put_materials_sort: 1,          // 排序
      e_put_materials_id: '',           // 投料ID
      e_put_materials_percentage: 0,    // 投料量
      e_put_materials_type: -1,         // 類型
      e_put_materials_action: '',       // 行為
      e_put_materials_description: '',   // 敘述
      e_put_materials_button_text: '',  // 按鈕文字
      e_put_materials_brix_high: 0,  // 糖度
      e_put_materials_brix_low: 0,   // 糖度
      e_put_materials_ph_high: 0,    // 酸度
      e_put_materials_ph_low : 0,    // 酸度
      e_put_materials_salinity_high: 0,    // 鹽度
      e_put_materials_salinity_low : 0,    // 鹽度      
      e_put_materials_pressure_high: 0,  // 壓力值
      e_put_materials_pressure_low : 0,  // 壓力值
      e_put_materials_temp_high: 0,  // 溫度
      e_put_materials_temp_low: 0,   // 溫度
      e_put_materials_initial_value : 0, // 初始化數值
      e_put_materials_proportion  : 0,   // 比重
      e_put_materials_refer_value  : 0,  // 參考液位值     
      e_put_materials_unit: 'L', // 單位
      e_put_materials_selectRow: null,  e_put_materials_selectData: null, 
      copyid:'',
      e_put_matera_buttons: [
        {click: this.editPutMaterialsOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ], 
      potTemplate: function () {
        return {
          template: Vue.component('potTemplate', {
            template: `<div> {{pot_n}} </div>`,
              data: function () { return { data: {} }; },
            computed: {
              pot_n : function () {  
                return  `${this.data.pot_name} ${this.data.cutting == true ? "-裁切機" : ""}`; 
              }
            }
          })
        }
      },        
    };
  },
  computed: {

  },
  methods: {


    onload: function () {
      // 初始化
    },  
    radiobuttonChange: function(args) {   
      this.isproduct = args.value == "put"
    },
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.status == 0) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },

    onRowDrop: function(args){
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Recipe/PutMaterials/Sort',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {           
            formula_id: this.e_formula_selectData.formula_id,
            sort_id: args.data[0].sort_id,
            from_index: args.fromIndex,
            drop_index : args.dropIndex            
          },        
      })
      .then((response) => {     
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
        this.getProduct();      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },

    // 投料    
    putMaterialsDoubleClick: function () {         
      this.e_put_materials_isAdd    = false;

      this.e_put_materials_status   = this.e_put_materials_selectData.status;
      this.e_put_materials_sort_id  = this.e_put_materials_selectData.sort_id;
      this.e_put_materials_unit     = this.e_put_materials_selectData.unit;          
      this.e_put_materials_pot      = this.e_put_materials_selectData.pot;
      this.e_put_materials_cutting  = this.e_put_materials_selectData.cutting;      
      this.e_put_materials_sort     = this.e_put_materials_selectData.sort;
      this.e_put_materials_id       = this.e_put_materials_selectData.put_materials_id;  
      this.e_put_materials_percentage = this.e_put_materials_selectData.put_percentage; 
      this.e_put_materials_type     = this.e_put_materials_selectData.type; 
      this.e_put_materials_action   = this.e_put_materials_selectData.action;
      this.e_put_materials_description   = this.e_put_materials_selectData.description;
      this.e_put_materials_button_text = this.e_put_materials_selectData.button_text;
      this.e_put_materials_brix_high = this.e_put_materials_selectData.brix_high;
      this.e_put_materials_brix_low = this.e_put_materials_selectData.brix_low;
      this.e_put_materials_ph_high  = this.e_put_materials_selectData.ph_high;
      this.e_put_materials_ph_low   = this.e_put_materials_selectData.ph_low;
      this.e_put_materials_salinity_high  = this.e_put_materials_selectData.salinity_high;
      this.e_put_materials_salinity_low   = this.e_put_materials_selectData.salinity_low;
      this.e_put_materials_pressure_high = this.e_put_materials_selectData.pressure_high;
      this.e_put_materials_pressure_low  = this.e_put_materials_selectData.pressure_low;
      this.e_put_materials_temp_high = this.e_put_materials_selectData.temp_high;
      this.e_put_materials_temp_low  = this.e_put_materials_selectData.temp_low;
      this.e_put_materials_initial_value = this.e_put_materials_selectData.initial_value;
      this.e_put_materials_proportion   = this.e_put_materials_selectData.proportion;
      this.e_put_materials_refer_value   = this.e_put_materials_selectData.refer_value;


      window.setTimeout(( () =>
        this.e_put_materials_type = this.e_put_materials_selectData.type      
      ), 100);
      this.$refs.putMaterialsDialog.show();
    },
   
    putMaterialsToolbarClick: function (args) {
      if(args.item.id == 'Add') {
        
        this.e_put_materials_isAdd = true;
        this.e_put_materials_status = 1;
        this.e_put_materials_sort_id = "add";
        this.e_put_materials_pot = 1;           // 桶次
        this.e_put_materials_cutting = false;  // 裁切機
        this.e_put_materials_sort = 1;          // 排序
        this.e_put_materials_id = '';           // 投料ID
        this.e_put_materials_percentage = 0;    // 投料量
        this.e_put_materials_type = -1;         // 類型
        this.e_put_materials_action =  '';      // 行為
        this.e_put_materials_description =  '';      // 行為
        this.e_put_materials_button_text =  '';  // 按鈕文字
        this.e_put_materials_brix_high = 0;  // 糖度
        this.e_put_materials_brix_low =  0;  // 糖度
        this.e_put_materials_ph_high =  0;    // 酸度
        this.e_put_materials_ph_low  =  0;   // 酸度
        this.e_put_materials_salinity_high = 0;    // 鹽度
        this.e_put_materials_salinity_low = 0;    // 鹽度     
        this.e_put_materials_pressure_high =  0;  // 壓力值
        this.e_put_materials_pressure_low  =  0; // 壓力值
        this.e_put_materials_temp_high =  0;  // 溫度
        this.e_put_materials_temp_low =  0;   // 溫度
        this.e_put_materials_initial_value  =  0;// 初始化數值
        this.e_put_materials_proportion  =  0;   // 比重
        this.e_put_materials_refer_value  =  0;  // 參考液位值     
        this.e_put_materials_unit = 'L';// 單位
   
        this.$refs.putMaterialsDialog.show();


      }
      if(args.item.id == 'Edit'){
        this.putMaterialsDoubleClick();
      }
      if(args.item.id == 'Copy'){
      this.copyid =this.e_formula_selectData.formula_id;
        this.$refs.toastRef.show( { title: '訊息!', content: `已複製${this.e_formula_selectData.formula_name}配方`, cssClass: 'e-toast-info', icon: 'e-warning toast-icons' }); 
      }
      if(args.item.id == 'Paste'){
        this.PostPasteRecipe();
      }
      if(args.item.id == 'Start' || args.item.id == 'Stop'){
        DialogObj = DialogUtility.confirm({
            title: '狀態變更',
            content: `確認是否要${this.e_put_materials_status == 0 ? '啟用' : '停用'}${this.e_put_materials_selectData.action}的投料資料嗎?`,
            okButton: {  text: '確認', click: this.statusPutMaterialsOkClick },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });        
      }
     
      if(args.item.id =='Delete') {          
        DialogObj = DialogUtility.confirm({
            title: '資料移除',
            content: `確認是否要移除${this.e_put_materials_selectData.action}的投料資料嗎?`,
            okButton: {  text: '確認', click: this.deletePutMaterialsOkClick },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });  
      }
      if(args.item.id =='Export'){
        this.$refs.refPutMaterials.excelExport({ fileName:`${this.e_formula_selectData.formula_name}投料內容.xlsx` });        
      }
    },
    putMaterialsCheckHeader: function() {   
      var dis = this.e_formula_selectRow == null;
      this.putMaterialsToolbar = this.e_put_materials_status == 0 ? 
        [
          { text: '新增', tooltipText: '新增投料', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: dis || this.limit.indexOf('22') < 0},
          { text: '修改', tooltipText: '修改投料', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('22') < 0},
          { text: '刪除', tooltipText: '刪除投料', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('22') < 0},
          { text: '複製配方', prefixIcon: 'e-btn-icon e-copy e-icons e-icon-left', id: 'Copy', disabled: dis|| this.limit.indexOf('22') < 0  },
          { text: '貼上配方', prefixIcon: 'e-btn-icon e-copy e-icons e-icon-left', id: 'Paste', disabled:dis || this.limit.indexOf('22') < 0  },
          { text: '啟用', tooltipText: '啟用投料', prefixIcon: 'e-btn-icon e-circle-check e-icons e-icon-left', id: 'Start', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('22') < 0},     
          { text: '匯出', tooltipText: '匯出投料', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export', disabled: dis  }, 'Search', 
        ]: 
        [
          { text: '新增', tooltipText: '新增投料', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: dis|| this.limit.indexOf('22') < 0},
          { text: '修改', tooltipText: '修改投料', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('22') < 0},
          { text: '刪除', tooltipText: '刪除投料', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('22') < 0},
          { text: '複製配方', prefixIcon: 'e-btn-icon e-copy e-icons e-icon-left', id: 'Copy', disabled: dis || this.limit.indexOf('22') < 0  },
          { text: '貼上配方', prefixIcon: 'e-btn-icon e-copy e-icons e-icon-left', id: 'Paste', disabled: dis || this.limit.indexOf('22') < 0  },
          { text: '停用', tooltipText: '停用投料', prefixIcon: 'e-btn-icon e-circle e-icons e-icon-left', id: 'Stop', disabled: this.e_put_materials_selectRow == undefined || this.limit.indexOf('22') < 0 },
          { text: '匯出', tooltipText: '匯出投料', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export', disabled: dis  }, 'Search', 
        ]
    },    
    putMaterialsRowSelected: function(args) {

      this.e_put_materials_selectRow = parseInt(args.row.getAttribute('aria-rowindex'));
      this.e_put_materials_selectData = args.data;
      this.e_put_materials_status = this.e_put_materials_selectData.status;
      this.putMaterialsCheckHeader();
    },    
    radiobuttonMonitorChange: function(args) {       
      if (args.value == "none") this.e_put_materials_type = -1;
      if (args.value == "put") this.e_put_materials_type = 0;
      if (args.value == "qc") this.e_put_materials_type = 1;
      if (args.value == "pressure") this.e_put_materials_type = 2;
      if (args.value == "level") this.e_put_materials_type = 3;
      if (args.value == "input") this.e_put_materials_type = 10;
      if (args.value == "select") this.e_put_materials_type = 11;
      if (args.value == "level_calculate") this.e_put_materials_type = 20;
      if (args.value == "cycle") this.e_put_materials_type = 21;
      if (args.value == "material") this.e_put_materials_type = 22;      

    },    
    editPutMaterialsOkClick: function() {

      
      if(( this.e_put_materials_ph_low>this.e_put_materials_ph_high)|| (this.e_put_materials_salinity_low>this.e_put_materials_salinity_high) || (this.e_put_materials_temp_low> this.e_put_materials_temp_high) || ( this.e_put_materials_brix_low> this.e_put_materials_brix_high)){
        if( this.e_put_materials_ph_low>this.e_put_materials_ph_high){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請正確填寫酸度高低值", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 
        }
        if( this.e_put_materials_salinity_low>this.e_put_materials_salinity_high){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請正確填寫鹽度高低值", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 

        }
        if( this.e_put_materials_temp_low> this.e_put_materials_temp_high){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請正確填寫溫度高低值", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 

        }
        if(  this.e_put_materials_brix_low> this.e_put_materials_brix_high){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請正確填寫糖度高低值", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); 

        }
        return;
      }

      this.showLoading();
      this.axios({
          method: this.e_put_materials_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Recipe/PutMaterials',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {            
            sort_id:      this.e_put_materials_sort_id,
            formula_id:   this.e_formula_selectData.formula_id,
            pot:          this.e_put_materials_pot,
            cutting:      this.e_put_materials_cutting,
            sort:         this.e_put_materials_sort, 
            type:         this.e_put_materials_type,
            put_materials_id: this.e_put_materials_id,
            put_percentage: this.e_put_materials_percentage ,
            temp_low:       this.e_put_materials_temp_low,
            temp_high:      this.e_put_materials_temp_high,
            brix_low:       this.e_put_materials_brix_low,  
            brix_high:      this.e_put_materials_brix_high,  
            ph_low:         this.e_put_materials_ph_low, 
            ph_high:        this.e_put_materials_ph_high, 
            salinity_high:  this.e_put_materials_salinity_high, 
            salinity_low:   this.e_put_materials_salinity_low, 
            pressure_low:   this.e_put_materials_pressure_low, 
            pressure_high:  this.e_put_materials_pressure_high, 
            refer_value:    this.e_put_materials_refer_value, 
            proportion:     this.e_put_materials_proportion, 
            initial_value:  this.e_put_materials_initial_value, 
            button_text:    this.e_put_materials_button_text, 
            unit:           this.e_put_materials_unit,         
            action:         this.e_put_materials_action,
            description:    this.e_put_materials_description
       
          },        
      })
      .then((response) => {     
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
        this.showMsg(this.e_put_materials_isAdd ? '新增成功!' : '修改成功!');     
        this.$refs.putMaterialsDialog.hide();    
        this.hideLoading();
        this.getProduct();
      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },
    statusPutMaterialsOkClick: function() {
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Recipe/PutMaterials/Status',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {            
            sort_id: this.e_put_materials_selectData.sort_id      
          },        
      })
      .then((response) => {     
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
        this.showMsg('變更狀態成功!');     
        DialogObj.hide(); 
        this.hideLoading();
        this.getProduct();
      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },
    deletePutMaterialsOkClick: function() {
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Recipe/PutMaterials',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {            
            sort_id: this.e_put_materials_selectData.sort_id      
          },        
      })
      .then((response) => {     
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
        this.showMsg('刪除成功!');     
        DialogObj.hide(); 
        this.hideLoading();
        this.getProduct();
      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },


    // 成品
    productDoubleClick: function () {         
      this.e_formula_isAdd = false;
      this.e_product_id = this.e_product_selectData.product_id;
      this.e_product_name = this.e_product_selectData.product_name;
      this.e_product_b_weight = this.e_product_selectData.b_weight;
      this.e_product_e_weight = this.e_product_selectData.e_weight;
      this.e_box_b_weight = this.e_product_selectData.b2_weight;
      this.e_box_e_weight = this.e_product_selectData.e2_weight;
      this.e_product_litron = this.e_product_selectData.litron_convert_modulus;    
      this.e_product_capacity = this.e_product_selectData.capacity;    
      this.$refs.ProductDialog.show();
    },

    productCheckHeader: function() {      
      var dis = this.e_formula_selectRow == null;
      this.productToolbar =
        [
          { text: '連結', tooltipText: '變更連結', prefixIcon: 'e-btn-icon e-repeat e-icons e-icon-left', id: 'Link', disabled : dis || this.limit.indexOf('22') < 0 },
          { text: '修改', tooltipText: '修改成品', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_product_selectRow == undefined || this.limit.indexOf('22') < 0 },      
          { text: '匯出', tooltipText: '匯出成品', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export',  disabled : dis}, 
        'Search']
    },     
    productRowSelected: function(args) {
      this.e_product_selectRow  = args.row.getAttribute('aria-rowindex');  
      this.e_product_selectData = args.data;

      // 取得用料
      this.getMaterial();
      this.productCheckHeader();
    },
    ProductToolbarClick: function (args) {
      if(args.item.id == 'Link') {
        this.e_product_isAdd = true;
        this.e_product_id = "";
        this.e_product_name = "";
        this.e_product_b_weight = "";
        this.e_product_e_weight = "";
        this.e_box_b_weight = "";
        this.e_box_e_weight = "";
        this.e_product_litron = "";
        this.e_product_capacity = "";
        this.$refs.ProductLinkDialog.show();
      }
      if(args.item.id == 'Edit'){
        this.e_product_isAdd = false;
        this.e_product_id = this.e_product_selectData.product_id;
        this.e_product_name = this.e_product_selectData.product_name;
        this.e_product_b_weight = this.e_product_selectData.b_weight;
        this.e_product_e_weight = this.e_product_selectData.e_weight;
        this.e_box_b_weight = this.e_product_selectData.b2_weight;
        this.e_box_e_weight = this.e_product_selectData.e2_weight;
        this.e_product_litron = this.e_product_selectData.litron_convert_modulus;
        this.e_product_capacity = this.e_product_selectData.capacity;
        this.$refs.ProductDialog.show();
      }
     
      if(args.item.id =='Export'){
        
        this.$refs.refProduct.excelExport({ fileName:`${this.e_formula_selectData.formula_name}成品.xlsx` });        
      }
    },
    cuttingOnchange: function (args) {
      this.e_put_materials_cutting = args.checked;
    },
    workOnchange: function () {
      this.e_put_materials_type = -1;
    },
    materialToolbarbarClick: function (args) {
      if(args.item.id =='Export'){
        console.log(this.e_product_selectData)
        this.$refs.refFormula.excelExport({ fileName:`${this.e_product_selectData.product_name}原料.xlsx` });        
      }
    },
    editProductOkClick: function() {
      if((this.e_product_e_weight<this.e_product_b_weight)||(this.e_box_e_weight<this.e_box_b_weight)){
        if(this.e_product_e_weight<this.e_product_b_weight){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請正確填寫充填重量高低值", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
        }
        if(this.e_box_e_weight<this.e_box_b_weight){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請正確填寫檢重機重量高低值", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
        }
        return;
      }
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Product`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {           
            formula_id: this.e_formula_selectData.formula_id,
            product_id: this.e_product_selectData.product_id,
            litron_convert_modulus : this.e_product_litron,
            capacity : this.e_product_capacity,
            b_weight: this.e_product_b_weight,
            e_weight: this.e_product_e_weight,
            b2_weight:this.e_box_b_weight,
            e2_weight:this.e_box_e_weight
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.showMsg('修改成品係數成功!');         
        this.$refs.ProductDialog.hide();
        this.hideLoading();
        this.getProduct();  
      })
      .catch((error) => { 
        this.showError(error, true) }
      )    
    },
    editProductLinkOkClick: function() {
      var listboxobj = document.getElementById("lis_product_bind").ej2_instances[0]; 
      this.showLoading();
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Product`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            datas: listboxobj.listData,
            formula_id: this.e_formula_selectData.formula_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.showMsg('建立連結成功!');         
        this.$refs.ProductLinkDialog.hide();
        this.hideLoading();
        this.getProduct();  
      })
      .catch((error) => { 
        this.showError(error, true) }
      )    
    },


    
    // 配方
    formulaDoubleClick: function () {         
      this.e_formula_isAdd = false;
      this.e_formula_id = this.e_formula_selectData.formula_id;
      this.e_formula_name = this.e_formula_selectData.formula_name;
      this.e_adjust_temp = this.e_formula_selectData.adjust_temp;
      this.e_adjust_brix = this.e_formula_selectData.adjust_brix;
    
      this.$refs.FormulaDialog.show();
    },
    formulaRowSelected: function(args) {
      this.e_formula_selectRow = args.row.getAttribute('aria-rowindex');  
      this.e_formula_selectData = args.data;    
      this.e_formula_status = args.data.status;

      // 取得成品
      this.getProduct();
      this.formulaCheckHeader();
      this.putMaterialsCheckHeader();
      this.productCheckHeader();
    },
    formulaCheckHeader: function() {      

      this.formulaToolbar = this.e_formula_status == 0 ? 
        [
          { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false || this.limit.indexOf('22') < 0 },
          { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_formula_selectRow == undefined || this.limit.indexOf('22') < 0  },
          { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_formula_selectRow == undefined || this.limit.indexOf('22') < 0  },
          { text: '啟用', tooltipText: '啟用', prefixIcon: 'e-btn-icon e-circle-check e-icons e-icon-left', id: 'Start', disabled: this.e_formula_selectRow == undefined || this.limit.indexOf('22') < 0  },     
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search', 
           ] : 
        [
          { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false || this.limit.indexOf('22') < 0  },
          { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_formula_selectRow == undefined || this.limit.indexOf('22') < 0  },
          { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_formula_selectRow == undefined || this.limit.indexOf('22') < 0  },
          { text: '停用', tooltipText: '停用', prefixIcon: 'e-btn-icon e-circle e-icons e-icon-left', id: 'Stop', disabled: this.e_formula_selectRow == undefined || this.limit.indexOf('22') < 0  },
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 'Search', 
          ]
    },     
    formulaToolbarClick: function (args) {
      if(args.item.id == 'Add') {
        this.e_formula_isAdd = true;
        this.e_formula_id = "";
        this.e_formula_name = ""; 
        this.e_adjust_temp = ""; 
        this.e_adjust_brix= "";  
        this.$refs.FormulaDialog.show();
      }
      if(args.item.id == 'Edit'){
        this.e_formula_isAdd = false;
        this.e_formula_id = this.e_formula_selectData.formula_id;
        this.e_formula_name = this.e_formula_selectData.formula_name;
        this.e_adjust_temp = this.e_formula_selectData.adjust_temp;
        this.e_adjust_brix = this.e_formula_selectData.adjust_brix;
        this.$refs.FormulaDialog.show();
      }
      if(args.item.id =='Start' || args.item.id =='Stop'){      
        DialogObj = DialogUtility.confirm({
            title: '狀態變更',
            content: `確認是否要${this.e_formula_status == 0 ? '啟用' : '停用'}${this.e_formula_selectData.formula_id}-${this.e_formula_selectData.formula_name}的資料嗎?`,
            okButton: {  text: '確認', click: this.statusFormulaOkClick },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });        
      }
      if(args.item.id =='Delete'){          
        DialogObj = DialogUtility.confirm({
            title: '資料刪除',
            content: `確認是否要刪除${this.e_formula_selectData.formula_id}-${this.e_formula_selectData.formula_name}的資料嗎?刪除後可能會影響系統!`,
            okButton: {  text: '確認', click: this.delFormulaOkClick },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });  
      }
      if(args.item.id =='Export'){
        this.$refs.refFormula.excelExport({ fileName: this.formatDate(new Date())+'配方紀錄.xlsx' });        
      }
    },
    PostPasteRecipe:function(){
       this.showLoading();
      this.axios({
          method: 'Post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/PasteRecipe`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            copyid: this.copyid,
            pasteid:this.e_formula_selectData.formula_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading();return; }              
        this.hideLoading();
        this.getProduct();  
       
      
      })
      .catch((error) => { 
        this.showError(error, true) }
      )    
    },
    delFormulaOkClick: function() { // 刪除配方
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Formula`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            formula_id: this.e_formula_selectData.formula_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.showMsg('刪除成功!');         
        DialogObj.hide();
        this.hideLoading();
        this.getFormula();  
       
      
      })
      .catch((error) => { 
        this.showError(error, true) }
      )    
    },
    statusFormulaOkClick: function() {  // 變更狀態配方
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Formula/Status`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            formula_id: this.e_formula_selectData.formula_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading();  return; }              
        this.showMsg('變更成功!');         
        DialogObj.hide();
        this.hideLoading();
        this.getFormula();  
      
      })
      .catch((error) => { 
        this.showError(error, true) }
      )    
    },
    editFormulaOkClick: function() { // 變更配方
      this.showLoading();
      this.axios({
          method: this.e_formula_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Recipe/Formula',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {            
            formula_id: this.e_formula_id,
            formula_name: this.e_formula_name,
            adjust_temp: this.e_adjust_temp,
            adjust_brix: this.e_adjust_brix                    
          },        
      })
      .then((response) => {     
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
        this.showMsg(this.e_formula_isAdd ? '新增成功!' : '修改成功!');     
        this.$refs.FormulaDialog.hide();    
        this.hideLoading();
        this.getFormula();
      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },
    getFormula: function () {  // 取得配方紀錄

      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Formula`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.hideLoading();    
        this.formulaDatas = response.data.datas   
        this.e_formula_selectRow = null; 
        this.formulaCheckHeader();  
        this.e_product_selectRow = null; 
        this.productCheckHeader();  
      
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    getProduct: function () {  // 取得成品
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Product?formula_id=${this.e_formula_selectData.formula_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.productDatas = response.data.datas.datas;
        this.hideLoading();    
        this.productNoneBindDatas = response.data.datas.none_bind;
        this.productBindDatas = response.data.datas.bind;
        this.putMaterialsData = response.data.datas.put_materials;
        this.potData = response.data.datas.pot;   
        this.materialsListData = response.data.datas.materials_list;   
        this.e_product_selectRow = null; 
        this.productCheckHeader();  
        this.materialDatas = null; 
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    getMaterial: function () {  // 取得用料
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Material?product_id=${this.e_product_selectData.product_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.materialDatas = response.data.datas   
      })
      .catch((error) => { 
        this.showError(error, true) }
      )             
    },
    formatDate(date) {
            let yyyy = date.getFullYear();
            let mm = String(date.getMonth() + 1).padStart(2, '0');      
            let dd = String(date.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'red',
        loader: 'dots',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [Selection, RowDD, PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {

    this.getFormula();
    this.formulaCheckHeader();
    this.putMaterialsCheckHeader();
    this.productCheckHeader();
  },
  mounted() {

  },
  beforeUpdate() {

  },
  beforeDestroy() {

  }
}
</script>
<style lang="scss" src="../../scss/base.scss"></style>
<style scoped>
    .control-section .dual-list-wrapper {
        width: 90%;
        margin: 0 auto 10px;
        display: flex;
    }
    .dual-list-groupa,
    .dual-list-groupb {
        width: 50%;
        padding-left: 15px;
    }
    .dual-list-groupb .e-listbox-wrapper.e-wrapper.e-lib,
    .dual-list-groupb h4 {
        width: 87%;
        margin-left: 5px;
    }
    @media screen and (max-width: 590px) {
        .control-section .dual-list-wrapper {
            width: 100%;
        }
        .dual-list-groupa {
            width: 56%;
        }
        .dual-list-groupb {
            width: 44%;
        }
    }
    @media screen and (max-width: 400px) {
        .dual-list-groupa {
            width: 59%;
        }
        .dual-list-groupb {
            width: 41%;
        }
    }
    .bootstrap5 .e-listboxtool-wrapper.e-lib.e-right,
    .bootstrap5 .e-listbox-wrapper.e-wrapper.e-lib,
    .bootstrap5-dark .e-listboxtool-wrapper.e-lib.e-right,
    .bootstrap5-dark .e-listbox-wrapper.e-wrapper.e-lib {
        height: 323px !important;
    }
   
</style>